<template>
  <div class="login-page">
    <div class="overlay">
      <div class="container h-100">
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-11 col-sm-8 col-md-6 col-lg-4">
            <div class="card shadow-lg rounded-4 p-4 bg-white bg-opacity-75 card-clinique">

              <!-- Titre -->
             <div class="text-center mb-3">
  <i class="bi bi-hospital fs-1 text-primary d-block mb-2"></i>

  <h4 class="fw-bold text-primary mb-1">
    Clinique Médicale DemAssi
  </h4>


  <h5 class="fw-bold mb-1">
    Connexion
  </h5>

  <small class="text-muted">
    Accédez à votre espace sécurisé
  </small>
</div>

              <!-- Alerte erreur globale -->
              <div v-if="globalError" class="alert alert-danger py-2" role="alert">
                {{ globalError }}
              </div>

              <!-- Formulaire -->
              <form @submit.prevent="login" novalidate>
                <!-- Email -->
                <div class="mb-3">
                  <label class="form-label fw-semibold" for="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    v-model.trim="email"
                    class="form-control form-control-clinique"
                    :class="{ 'is-invalid': error.email }"
                    placeholder="ex: user@domaine.com"
                    autocomplete="username"
                    autofocus
                    :disabled="isLoading"
                  />
                  <div class="invalid-feedback">{{ error.email }}</div>
                </div>

                <!-- Mot de passe -->
                <div class="mb-2">
                  <label class="form-label fw-semibold" for="password">Mot de passe</label>
                  <div class="input-group">
                    <input
                      :type="showPassword ? 'text' : 'password'"
                      id="password"
                      v-model.trim="password"
                      class="form-control form-control-clinique"
                      :class="{ 'is-invalid': error.password }"
                      placeholder="Votre mot de passe"
                      autocomplete="current-password"
                      :disabled="isLoading"
                    />
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="showPassword = !showPassword"
                      :disabled="isLoading"
                      title="Afficher/Masquer"
                    >
                      <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                    </button>
                    <div class="invalid-feedback d-block">{{ error.password }}</div>
                  </div>
                </div>

                <!-- Options -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="remember" v-model="remember" :disabled="isLoading" />
                    <label class="form-check-label" for="remember">Se souvenir de moi</label>
                  </div>
                  <!-- Lien placeholder (facultatif) 
                  <a href="#" class="small text-decoration-none" @click.prevent>Mot de passe oublié ?</a>-->
                </div>

                <!-- Bouton -->
                <button type="submit" class="btn btn-primary w-100 btn-clinique" :disabled="isLoading">
                  <span v-if="isLoading" class="d-inline-flex align-items-center gap-2">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Connexion en cours...
                  </span>
                  <span v-else>
                    <i class="bi bi-box-arrow-in-right me-1"></i> Se connecter
                  </span>
                </button>
              </form>

            </div>
            <!-- Footer mini -->
            <p class="text-center text-white mt-3 small mb-0 fw-semibold">
  © {{ new Date().getFullYear() }} Clinique Médicale DemAssi
</p>

<p class="text-center text-white-50 small mb-0">
  Plateforme de gestion médicale
</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Loader plein écran en overlay (optionnel) -->
    <transition name="fade">
      <div v-if="isLoading" class="global-loader d-flex align-items-center justify-content-center">
        <div class="text-center">
          <div class="spinner-border text-light" role="status" style="width: 3rem; height: 3rem;"></div>
          <div class="mt-2 text-white-50">Vérification des identifiants...</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      remember: false,
      showPassword: false,
      isLoading: false,
     // globalError: '',
      globalError: this.$route.query.message || '',
      error: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    validate() {
      // reset
      this.globalError = '';
      this.error = { email: '', password: '' };

      // email
      if (!this.email) {
        this.error.email = "L'email est requis.";
      } else {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!re.test(this.email)) {
          this.error.email = "L'email n'est pas valide.";
        }
      }

      // password
      if (!this.password) {
        this.error.password = 'Le mot de passe est requis.';
      } else if (this.password.length < 4) {
        this.error.password = 'Le mot de passe doit contenir au moins 4 caractères.';
      }

      return !this.error.email && !this.error.password;
    },

    async login() {
  if (!this.validate() || this.isLoading) return;

  this.isLoading = true;
  this.globalError = '';

  try {
    // On récupère un objet { success, disabled } depuis l'action Vuex
    const result = await this.$store.dispatch('authenticate', {
      email: this.email,
      password: this.password,
      remember: this.remember
    });

    if (result.success) {
      this.$router.push('/');
    } else if (result.disabled) {
      // Cas compte désactivé
      this.globalError = 'Votre compte est désactivé.';
    } else {
      // Identifiants incorrects
      this.globalError = 'Identifiants incorrects. Vérifiez votre email ou mot de passe.';
    }
  } catch (e) {
    this.globalError = 'Une erreur est survenue. Veuillez réessayer.';
  } finally {
    this.password = '';
    this.isLoading = false;
  }
}

  },
  watch: {
  '$route.query.message'(newMessage) {
    this.globalError = newMessage || '';
  }
}
};

</script>

<style scoped>
/* --- Plein écran avec image de fond --- */
.login-page {
  min-height: 100vh;
  width: 100%;
  background-image: url('@/assets/img/24285.jpg'); 
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

/* --- Overlay sombre pour lisibilité --- */
.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,.35), rgba(0,0,0,.6));
}

/* --- Carte et champs style "clinique" (cohérent avec tes autres pages) --- */
.card-clinique {
  border: none;
  backdrop-filter: blur(4px);
}

.form-control-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.2s ease;
}
.form-control-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* Bouton gradient comme tes autres pages */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: transform .15s ease, box-shadow .2s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,.2);
  transform: translateY(-2px);
}

/* Loader plein écran (optionnel) */
.global-loader {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.35);
  z-index: 1055;
}

/* Transition fondu pour le loader */
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Petits écrans */
@media (max-width: 575.98px) {
  .card-clinique {
    padding: 1.25rem !important;
  }
}
</style>
